import s from "./ownerCabinet.module.css";

export function OwnerPage({ title, subtitle, actions, children }) {
  return (
    <div className={s.page}>
      <header className={s.pageHeader}>
        <div className={s.pageHeaderText}>
          <h1 className={s.pageTitle}>{title}</h1>
          {subtitle ? <p className={s.pageSubtitle}>{subtitle}</p> : null}
        </div>
        {actions ? <div className={s.pageHeaderActions}>{actions}</div> : null}
      </header>
      {children}
    </div>
  );
}

export function OwnerPanel({ title, children, className = "" }) {
  return (
    <section className={`${s.panel} ${className}`.trim()}>
      {title ? <h2 className={s.panelTitle}>{title}</h2> : null}
      {children}
    </section>
  );
}

export function OwnerState({ children, variant = "muted" }) {
  return <div className={`${s.state} ${s[`state_${variant}`]}`}>{children}</div>;
}
